module.exports = __webpack_public_path__ + "img/c7.123a94ed.png";